import { TeamAccessDTO } from '../team/team-access.dto';

export class AddressListDTO extends TeamAccessDTO {

    id: string;

    address: string;

    city: string;

    zip: string;

    country: number;

    note: string;

    type: number;

}
